import React from 'react';
import { StarIcon } from 'lucide-react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function HeroSection() {
  return <section className="w-full py-8 md:py-16 px-4 bg-[#FFFFFF]" data-id="element-180">
      <div className="max-w-3xl mx-auto text-center" data-id="element-181">
        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-black font-heading text-gray-900 leading-tight mb-3" data-id="element-182">
          Regresa la calma a casa en tan solo{' '}
          <span className="text-red-600" data-id="element-183">7 días</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-700 italic mb-6 font-body" data-id="element-184">
          Acompaña a tu hijo sin gritos, sin culpa y con un sistema claro
        </p>

        {/* Product Image */}
        <div className="my-8 cursor-pointer" onClick={scrollToPricing} data-id="element-185">
          <img src="https://cdn.magicpatterns.com/uploads/cK47qtbMUa9xeq7QS1iGs2/mockup_principal.png" alt="MegaPack TDAH en Retroceso - 5 tomos completos" className="w-full max-w-2xl mx-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" width={665} height={426} fetchPriority="high" decoding="async" data-id="element-186" />
        </div>

        <p className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto font-body leading-relaxed" data-id="element-187">
          El sistema que ya están utilizando cientos de madres y padres para
          acompañar el comportamiento de sus hijos desde casa — sin improvisar,
          sin gritar y sin sentirse desbordados.
        </p>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8" data-id="element-188">
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-189">
            <span className="text-2xl" data-id="element-190">📄</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-191">
              100% digital (PDF)
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-192">
            <span className="text-2xl" data-id="element-193">⚡</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-194">
              Acceso inmediato
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-195">
            <span className="text-2xl" data-id="element-196">🌍</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-197">
              Funciona en cualquier país hispanohablante
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-198">
            <span className="text-2xl" data-id="element-199">👨‍👩‍👧‍👦</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-200">
              Para niños de 4 a 10 años
            </p>
          </div>
        </div>

        {/* CTA Button */}
        <button onClick={scrollToPricing} className="w-full md:w-auto bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-xl md:text-2xl px-10 py-5 rounded-xl shadow-lg animate-pulse-glow transition-colors duration-200 cursor-pointer font-heading" data-id="element-201">
          👉 QUIERO MI MEGAPACK AHORA
        </button>

        {/* Security Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-6 text-sm text-gray-500" data-id="element-202">
          <span data-id="element-203">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-204">🔒 Pago 100% seguro</span>
          <span data-id="element-205">💳 Pagas en la moneda de tu país</span>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 border-t border-b border-gray-200 py-6" data-id="element-206">
          <div className="text-center" data-id="element-207">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-208">
              +1.500
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-209">familias acompañadas</p>
          </div>
          <div className="text-center" data-id="element-210">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-211">
              5
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-212">tomos completos</p>
          </div>
          <div className="text-center" data-id="element-213">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-214">
              4.8/5
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-215">calificación ⭐</p>
          </div>
          <div className="text-center" data-id="element-216">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-217">
              🌍
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-218">
              Todo el mundo hispanohablante
            </p>
          </div>
        </div>

        {/* Initial Testimonials */}
        <div className="mt-10 space-y-4" data-id="element-219">
          <div className="bg-gray-50 rounded-xl p-5 text-left" data-id="element-220">
            <div className="flex gap-0.5 mb-2" data-id="element-221">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-222" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-223" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-224" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-225" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-226" />
            </div>
            <p className="text-gray-800 italic font-body" data-id="element-227">
              "Mi casa volvió a la calma en menos de una semana"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-228">
              — Mariana G. | Mamá de niño de 6 años
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 text-left" data-id="element-229">
            <div className="flex gap-0.5 mb-2" data-id="element-230">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-231" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-232" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-233" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-234" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-235" />
            </div>
            <p className="text-gray-800 italic font-body" data-id="element-236">
              "Dejé de gritar… y mi hijo empezó a escuchar"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-237">
              — Laura P. | Mamá de niño de 8 años
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 text-left" data-id="element-238">
            <div className="flex gap-0.5 mb-2" data-id="element-239">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-240" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-241" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-242" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-243" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-244" />
            </div>
            <p className="text-gray-800 italic font-body" data-id="element-245">
              "Ahora entiendo lo que le pasa y sé qué hacer"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-246">
              — Rodrigo M. | Papá
            </p>
          </div>
        </div>
      </div>
    </section>;
}